module.exports = __webpack_public_path__ + "static/media/wind.bb667036.svg";